import toast from 'react-hot-toast'

import { useMutation } from '@fv/client-core'
import type { LoadDocument } from '@fv/client-types'

import { useCacheHelpers } from '@/hooks/opportunities'
import type { Opportunity } from '@/types/Opportunity'
import { carrierFetch } from '@/utils/carrierFetch'

interface DeleteOpts {
  document: LoadDocument
  loadId: string
}
async function deleteDocument({ document, loadId }: DeleteOpts) {
  return await carrierFetch<Opportunity>(
    `/loads/${loadId}/documents/${document._id}`,
    {
      method: 'DELETE',
    },
  )
}

export function useDeleteDocument() {
  const { updateOppCaches } = useCacheHelpers()

  return useMutation(deleteDocument, {
    onSuccess: opportunity => {
      updateOppCaches(opportunity, ['archived', 'confirmed'])

      toast.success('Document deleted successfully.')
    },
  })
}
